import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CSVLink } from "react-csv";
import { FiDownload } from "react-icons/fi";
import { useApi } from "../../services/api";

export const NewContractsChart = () => {
  const { apiFetch } = useApi();
  const [windows, setWindows] = useState([]);

  useEffect(() => {
    async function loadData() {
      apiFetch("/api/analytics/newContracts")
        .then((response) => response.json())
        .then((data) => {
          setWindows(Array.isArray(data) ? data : []);
        })
        .catch(() => {
          alert("Error occured while loading new contracts");
        });
    }
    loadData();
  }, [apiFetch]);

  const options = {
    chart: { type: "column", height: 300 },
    title: { text: null },
    credits: { enabled: false },
    xAxis: { categories: windows.map((row) => "Last " + row.days + " days") },
    yAxis: { title: { text: "New contracts" }, allowDecimals: false },
    legend: { enabled: false },
    series: [
      {
        name: "New contracts",
        data: windows.map((row) => row.new_contracts),
        color: "#4A42A0",
      },
    ],
  };

  const csvData = windows.map((row) => ({
    Window: "Last " + row.days + " days",
    "New Contracts": row.new_contracts,
  }));

  return (
    <Card className="shadow" data-testid="newContractsCard">
      <CardBody>
        <CardTitle style={{ textAlign: "left", display: "flex", justifyContent: "space-between" }}>
          <span>New Contracts</span>
          <CSVLink data={csvData} filename={"new_contracts.csv"} data-testid="newContractsCsvLink">
            <FiDownload style={{ color: "#4A42A0" }} />
          </CSVLink>
        </CardTitle>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </CardBody>
    </Card>
  );
};
